<template>
  <div>
	You need to pass a client key
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>